import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var UnPinIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsxs("g", {
                        children: [
                            _jsx("path", {
                                d: "M6.635 6.857L8.58 8.801l-.318 2.382-.343.252c-.82.6-1.463 1.48-1.927 2.663l-.112.302 8.3.001 1.998 1.999H12.7v4.888a.5.5 0 01-.128.334l-.506.565a.5.5 0 01-.743.002l-.494-.545a.5.5 0 01-.129-.336V16.4H5.2a1.5 1.5 0 01-.27-.025l-.133-.03a1.5 1.5 0 01-1.042-1.848c.476-1.704 1.232-3.07 2.273-4.078l.227-.21.134-.114.353-2.644-.107-.594zM15.826.6a1.5 1.5 0 011.39 2.063l-.049.121-.048.118-.187.435-.177.381a5.356 5.356 0 01-.471.818l-.09.114-.168.192.701 5.252.134.114c1.005.888 1.764 2.086 2.28 3.579l.115.35.106.36a1.5 1.5 0 01.031.673h-.001l-1.378-1.379-3.248-3.247-.86-6.462.403-.353c.124-.109.24-.228.349-.359a.99.99 0 00.074-.106l.045-.074.102-.192.029-.056.03-.06.131-.282-6.055-.004-1.897-.001H6.82a11.36 11.36 0 01-.131-.13l-.824-.822c.155-.477.553-.856 1.102-.999l.146-.032.18-.012h8.534z"
                            }),
                            _jsx("path", {
                                d: "M.293 1.707l22 22a1 1 0 001.414-1.414l-22-22A1 1 0 10.293 1.707z"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
UnPinIcon.isCarinaIcon = true;
export default UnPinIcon;
